import { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllStainresults,CreateStainResults,UpdateStainResults,DeleteStainResults} from '../../services/micro/micro'

export const useStainResults = () => {

    const [createSweet] = useSweetAlert();
    const [listBacteriumCount, setListBacteriumCount] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchListBacteriumCount, setSearchListBacteriumCount] = useState([])

    // ? MODAL CRUD
    const [modal, setModal] = useState(false)
    const [tittle, setTittle] = useState("")
    const [method, setMethod] = useState("")
    const [id_resistance, setId_resistance] = useState(0);
    const [titleDelete, setTitleDelete] = useState("")

    // ? Alert Modal
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    // ? search 
    const [searchResults, setSearchResults] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);


    // * FORM 
    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name:"",
    });

    const {
        name,
    } = formValues;
   
    useEffect(() => {
        getBacteriumCount()
    }, []);
    
    const getBacteriumCount = async (_type) =>
        {
            const resistance = await getAllStainresults();    

            if (resistance?.length > 0)
            {
                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;
                let _new_list = [];

                endItems = aux;
                startItems = endItems - numberItems;

                resistance.forEach((_find,_key) => {
                    let posicion = _key + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }
                    _new_list.push({
                        id_mic_stain_result: _find?.id_mic_stain_result ?? null,
                        name: _find?.name ?? null,
                        visibleTable: visibleTable,
                    })
                });
                setListBacteriumCount(_new_list);      
                setSearchListBacteriumCount(_new_list)              
            }
    }

   const openDialog = (title, mode) => {
        setTittle(title);
        setMethod(mode);
        setModal(true);
    };
    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);
        setShowDeleteAlert(false);
    };


    // * CRUD TABLE
    const handleCreate = () => 
    {        
        handleUpdateValues({
            name:"",
        })
        setTittle("Crear Resultados")
        setMethod("create")
        openDialog("Crear resultado", "create");
    }

    const saveCreate =async (e) => 
    {
        e.preventDefault();
        
        setLoading(true);
        const response = await CreateStainResults({
            name: formValues.name,  
        });

        if (response.code === 200){
            setLoading(false);
            getBacteriumCount()
            createSweet("success", "success", "Se a creado correctamente");
            closeDialog();
            handleUpdateValues({
                name:"",
            })
        } 
    }

    const handleUpdate = (id_mic_stain_result) => 
    {
        let list = listBacteriumCount.find(c => c.id_mic_stain_result === parseInt(id_mic_stain_result));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list?.name,
            });
            setTittle("Actualizar")
            setId_resistance(id_mic_stain_result)
            setMethod("update")
            openDialog("Editar resultado", "update");
        }
    }

    const saveUpdateBacterium = async (e) => 
    {
        e.preventDefault();
        setLoading(true);

        const response = await UpdateStainResults({
            id_mic_stain_result: id_resistance,
            name: formValues.name,   
        });

        if (response.code === 200){
                setLoading(false);
                createSweet("success", "success", "Se a actualizado correctamente");
                getBacteriumCount()
                closeDialog()
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    const handleDelete = (id_mic_stain_result,_name) => 
    {
        let list = listBacteriumCount.find(c => c.id_mic_stain_result === parseInt(id_mic_stain_result));

        if (list !== "" || list !== null) {

            handleUpdateValues({
                name: list.name,
            });
            setTitleDelete(list.name)
            setId_resistance(id_mic_stain_result)
            setMethod("delete")
            openDeleteAlert();
        }
    }

    const saveDeleteBacterium= async (e) => 
    {
        e.preventDefault();
    
        setLoading(true);
    
        const response = await DeleteStainResults({
            id_mic_stain_result : id_resistance
        });
    
        if (response.code === 200){
            setLoading(false);
            createSweet("success", "success", "Se a eliminado correctamente");
            closeDeleteAlert()
            getBacteriumCount()
            handleUpdateValues({
                name:"",
            })
            setId_resistance(0);
        } 
    }

    // ? PAGINATION 
    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listBacteriumCount.length, numberItems);

    useEffect(() => {

        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;

        let listcompanies = [];
        listBacteriumCount.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listcompanies.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListBacteriumCount(listcompanies);

    }, [totalPageCount, currentPage]);
   
    // ? SEARCH TYPE DISCOUNT
    const handleSearch = (e) => {
        setSearchResults(e);
        let busqueda = e.toUpperCase();
        let newMethod = [];

        searchListBacteriumCount.forEach(element => {

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });
        setListBacteriumCount(newMethod);
    }

    const handleClearResults = () => {
        setSearchResults("");
        localStorage.removeItem("globalFilter");   
        setListBacteriumCount(searchListBacteriumCount); 
    }


    const handleExportExcelResults = async () => {
        setLoadingExport(true);
        try {
            const XLSX = await import("xlsx");

          const _report = listBacteriumCount.map((item, index) => ({
                "#": index + 1,
                Resultados: item.name ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Resultados");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_Resultados.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };



    return {
        // * LIST
        listBacteriumCount,

        // * PAGINATION
        totalPageCount, currentPage, nextPage, previousPage, goToPage,

        //* CRUD TABLE
        handleCreate,handleUpdate,handleDelete,method,modal,tittle,
        name,handleInputChange,titleDelete,
        saveCreate,saveUpdateBacterium,saveDeleteBacterium,loading,

        handleExportExcelResults,

        //* SEARCH
        handleSearch, handleClearResults, searchResults, loadingExport, 

        //*DIALOG
        closeDeleteAlert, closeDialog,
        showDeleteAlert, modalAlert, 



    }
}
